import type { BarrioComunaLookup } from '@src/modules/shared/locations/domain/barrioComunaLookup.ts';
import type { RedencionBonoCatalogSnapshot } from '@src/modules/redencion_bono/domain/redencionBonoModel.ts';
import type { OfflineSyncPuntosEntregaExportPort } from '../domain/ports/offlineSyncExportPorts.ts';

/** Mirrors API examples where catalog `participantes.public_id` may be transmitted as JSON number when purely digits. */
export function catalogPublicIdForWire(raw: string): string | number {
  const t = raw.trim();
  if (t === '') return '';
  if (/^\d+$/.test(t)) {
    const n = Number(t);
    if (Number.isFinite(n) && Number.isSafeInteger(n) && n >= 0) return n;
  }
  return t;
}

export function comunaNombreById(lookup: BarrioComunaLookup, comunaId: number): string {
  return lookup.listComunas().find((c) => c.id === comunaId)?.nombre ?? '';
}

export function barrioNombreById(lookup: BarrioComunaLookup, barrioId: number): string {
  for (const c of lookup.listComunas()) {
    const b = lookup.listBarriosByComuna(c.id).find((x) => x.id === barrioId);
    if (b) return b.nombre;
  }
  return '';
}

export function tipoBonoNombreFrom(
  catalog: RedencionBonoCatalogSnapshot,
  tipoBonoId: number | null,
): string {
  if (tipoBonoId == null || tipoBonoId <= 0) return '';
  return catalog.tiposBonos.find((t) => t.id === tipoBonoId)?.nombre ?? '';
}

/** Wire `publicId` + resolver `documento` from synced participant catalog (`participantes`). */
export function participanteCatalogWire(
  pe: OfflineSyncPuntosEntregaExportPort,
  participanteId: number,
): { publicId: string | number; documento: string } {
  const row = pe.findParticipanteById(participanteId);
  const documento = (row?.documento ?? '').trim();
  const publicId = catalogPublicIdForWire(row?.catalogPublicId ?? '');
  return { publicId, documento };
}
